@if (!uploadComplete) {
  <app-video-recording
    [is2ndDevice]="true"
    (videoUploadState)="onVideoUploadState($event)"
  ></app-video-recording>
}